export enum AdyenSessionErrorType {
  DROP_IN_TRANSACTION_REFUSED = 'DROP_IN_TRANSACTION_REFUSED',
  DROP_IN_GENERAL_ERROR = 'DROP_IN_GENERAL_ERROR',
  DROP_IN_SUCCESS = 'DROP_IN_SUCCESS',
  DROP_IN_WAITING = 'DROP_WAITING'
}
